export default __webpack_public_path__ + "static/media/zalando.99b81be8.svg";